import React, { useEffect, useState } from "react";

import { AxiosError } from "axios";

import { resetAnalytics, trackIdentity } from "../analytics/analytics";
import { BrandingProvider } from "../branding";
import { AccessDenied, UserProfileError } from "../components/ErrorDisplay";
import { Spinner } from "../components/ui/spinner";
import { useFetchUserInfo } from "../hooks/useFetchUserInfo";

export const UserProvider: React.FunctionComponent<{
  children: React.ReactNode;
  onAnalyticsEnabled?: () => void;
  enableBranding?: boolean;
}> = ({ children, onAnalyticsEnabled, enableBranding = true }) => {
  const { data: userInfo, isLoading, error } = useFetchUserInfo();
  const [analyticsInitialized, setAnalyticsInitialized] = useState(false);

  useEffect(() => {
    if (userInfo?.public_uuid && !analyticsInitialized) {
      resetAnalytics();
      trackIdentity(userInfo.public_uuid);
      onAnalyticsEnabled?.();
      setAnalyticsInitialized(true);
    }
  }, [userInfo?.public_uuid, onAnalyticsEnabled, analyticsInitialized]);

  if (isLoading) return <Spinner size="lg" className="mx-auto" />;

  if (error) {
    if (error instanceof AxiosError && error.response?.status === 401) {
      return <AccessDenied />;
    }
    return <UserProfileError error={error} />;
  }

  if (!analyticsInitialized) return <Spinner size="lg" className="mx-auto" />;

  if (!enableBranding) return <>{children}</>;

  return (
    <BrandingProvider userBranding={userInfo?.branding}>
      {children}
    </BrandingProvider>
  );
};
